import moment from 'moment';
import { regEx, patternType } from './constant';
import CryptoJS from 'crypto-js';

String.prototype.toTitleCase = function () {
    return this.replace(/\w\S*/g, function (word) {
        return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
    });
};

export function getOSInfo() {
    let name = "Not known",
        version = "Not known";
    if (navigator.appVersion.indexOf("Win") !== -1) name =
        "Windows";
    else if (navigator.appVersion.indexOf("Mac") !== -1) name =
        "Mac";
    else if (navigator.appVersion.indexOf("X11") !== -1) name =
        "UNIX";
    else if (navigator.appVersion.indexOf("Linux") !== -1) name =
        "Linux";

    version = parseFloat(navigator.appVersion).toString()
    return { name, version }
}

export function getBrowserInfo() {
    let userAgent = navigator.userAgent;
    let name = "Not known";
    if (userAgent.indexOf('Chrome') !== -1) {
        name = 'Chrome'
    }
    else if (userAgent.indexOf('Opera') !== -1) {
        name = 'Opera'
    }
    else if (userAgent.indexOf('Safari') !== -1) {
        name = 'Safari'
    }
    else if (userAgent.indexOf('Firefox') !== -1) {
        name = 'Firefox'
    }
    return { name }
}

export function getLocalIp(listnerFunc) { //  onNewIp - your listener function for new IPs
    //compatibility for firefox and chrome
    let myPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
    let pc = new myPeerConnection({
        iceServers: []
    }),
        noop = function () { },
        localIPs = {},
        ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;

    function iterateIP(ip) {
        if (!localIPs[ip]) listnerFunc(ip);
        localIPs[ip] = true;
    }
    // onNewIP
    //create a bogus data channel
    pc.createDataChannel("");

    // create offer and set local description
    pc.createOffer().then(function (sdp) {
        sdp.sdp.split('\n').forEach(function (line) {
            if (line.indexOf('candidate') < 0) return;
            line.match(ipRegex).forEach(iterateIP);
        });

        pc.setLocalDescription(sdp, noop, noop);
    }).catch(function (reason) {
        // An error occurred, so handle the failure to connect
    });

    //listen for candidate events
    pc.onicecandidate = function (ice) {
        if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return;
        ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
    };
}

export function getPublicIp(listnerFunc) {
    return fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(data => {
            console.log('data', data)
            listnerFunc(data.ip)
        }
        )
}

export function getUserMachineIp() {
    return new Promise((resolve, reject) => {
        // getLocalIp(resolve)
        getPublicIp(resolve)
    })
}

export function isValidPanNumber(panNumber) {
    const panRegex = RegExp(regEx.panRegex);
    return panRegex.test(panNumber)
}

export function isValidUserId(userId) {
    const panRegex = RegExp(regEx.userIdRegex);
    return panRegex.test(userId)
}

export function isValidMobileNo(mobileNo) {
    const panRegex = RegExp(regEx.mobileNumber);
    return panRegex.test(mobileNo)
}

export function isValidNumber(number) {
    const numberRegex = RegExp(regEx.number);
    return numberRegex.test(number)
}

export function isValidEmail(email) {
    const panRegex = RegExp(regEx.email);
    return panRegex.test(email)
}

export function isValidOtp(otp) {
    const otpRegex = RegExp(regEx.otpRegex);
    return otpRegex.test(otp);
}

export function removeDuplicates(array) {
    return array.filter((a, b) => array.indexOf(a) === b)
}

export function intersectionOfArray(array1, array2) {
    return array1.filter((element) => array2.indexOf(element) > -1);
}

export function isValidAlphaNumeric(value) {
    const alphaNumericRegex = RegExp(regEx.alphaNumeric);
    return alphaNumericRegex.test(value);
}
export function numberText(data) {
    let check = RegExp(regEx.number);
    return check.test(data)
}

export function floatNumberTex(data) {
    console.log("floatNumberTex req", data);
    let check = RegExp(regEx.numberWithSingleDecimal);
    console.log("floatNumberTex res", check.test(data));
    return check.test(data);
    // ^(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$

}

export function isValidAlphabates(value) {
    const alphaRegex = RegExp(regEx.alphabates);
    return alphaRegex.test(value);
}

export function isValidAlphabatesWithSpace(value) {
    const alphaRegex = RegExp(regEx.alphabatesWithSpace);
    return alphaRegex.test(value);
}

export function isValidInteger(value) {
    const alphaRegex = RegExp(regEx.alphabates);
    return alphaRegex.test(value);
}

export function isValidFloat(value) {
    const floatRegex = RegExp(regEx.float);
    return floatRegex.test(value);
}

export function isValidPattern(value, pattern) {
    switch (pattern) {
        case patternType.alphaNumeric:
            return isValidAlphaNumeric(value)
        case patternType.alphabates:
            return isValidAlphabates(value)
        case patternType.numeric:
            return isValidNumber(value)
        // case patternType.float:
        //     return isValidFloat(value)
        default:
            return true
    }
}

export const delay = (time) => {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve();
        }, time);
    })
}

export const amountToWords = (num) => {
    var a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
    var b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
    if ((num = num.toString()).length > 11) return 'overflow';
    let n = ('00000000000' + num).substr(-11).match(/^(\d{2})(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return; var str = '';
    str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'billion ' : '';
    str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'crore ' : '';
    str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'lakh ' : '';
    str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'thousand ' : '';
    str += (n[5] != 0) ? (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + 'hundred ' : '';
    str += (n[6] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[6])] || b[n[6][0]] + ' ' + a[n[6][1]]) + '' : '';
    return str;
}

export const capitalizeFirstLetter = (string) => {
    if (!string) return string; // Handle empty or undefined string
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const calculateFrequency = (startDate, endDate, frequency) => {
    console.info("startDate, endDate, frequency", startDate, endDate, frequency);
    let sDate = new Date(startDate); //, 'YYYY-MM-DD').format('DD-MM-YYYY');
    let eDate = new Date(endDate);
    console.info("sDate", sDate);
    console.info("eDate", eDate);
    let instCount = "";
    if (frequency.toLowerCase() === "monthly") {
        const diff = moment(eDate, "DD-MM-YYYY").diff(sDate, "months");
        console.info("diff", diff);
        instCount = diff
    }
    if (frequency.toLowerCase() === "yearly") {
        const diff = moment(eDate, "DD-MM-YYYY").diff(sDate, "years");
        instCount = diff
    }
    if (frequency.toLowerCase() === "daily") {
        const diff = moment(eDate, "DD-MM-YYYY").diff(sDate, "days");
        instCount = diff
    }
    if (frequency.toLowerCase() === "weekly") {
        const diff = moment(eDate, "DD-MM-YYYY").diff(sDate, "weeks");
        instCount = diff
    }
    if (frequency.toLowerCase() === "fortnightly") {
        const diff = moment(eDate, "DD-MM-YYYY").diff(sDate, "weeks");
        instCount = diff / 2
    }
    if (frequency.toLowerCase() === "quarterly") {
        const diff = moment(eDate, "DD-MM-YYYY").diff(sDate, "years");
        instCount = diff * 4
    }
    if (frequency.toLowerCase() === "half yearly") {
        const diff = moment(eDate, "DD-MM-YYYY").diff(sDate, "years");
        instCount = diff * 2
    }
    return instCount;
}

export const maskAccNumber = (data) => {
    // data should come in string;
    data = data?.replace(/\d(?=\d{4})/g, "*")
    return data || "";
}

export const checkLogOut = (data) => {
    if (data?.hasOwnProperty('code') && data?.code === 401) {
        return true;
    } else {
        return false;
    }
}

export const roundOff = (num) => {
    if (num) {
        var with2Decimals = num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
        return with2Decimals;
    }
    return num;
}

export function fetchWithWait({ dispatch, action }) {
    return new Promise((resolve, reject) => {
        dispatch({ ...action, resolve, reject })
    })
}

export function convertISOFormat(date) {
    const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    let formatted_date = date.getDate() + "/" + (months[date.getMonth()]) + "/" + date.getFullYear();
    return formatted_date
}

export function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}

export const availablePlanType = [
    {
        id: "R",
        label: "Regular"
    },
    {
        id: "D",
        label: "Direct"
    },
    {
        id: "RIA",
        label: "RIA"
    },
];

//#region addDays. returns true if given date >= (today's date + given days)
export function addDays(date, days) {
    var start = new Date(date);
    var result = new Date();
    result.setDate(result.getDate() + days);
    start = new Date(start.getFullYear(), start.getMonth(), start.getDate())
    result = new Date(result.getFullYear(), result.getMonth(), result.getDate())
    if (start >= result) {
        return true;
    } else {
        return false;
    }

}
//#endregion

//#region frequencyProcessing

export function frequencyProcessing(frequency) {
    let data = []
    frequency.forEach(function (element, index) {
        data[element.frequency + '_' + element.minNoOfInstalments] = []
        data[element.frequency + '_' + element.minNoOfInstalments].push(element)
    });
    return data;
}

//#endregion

//#region evaluate_sip_error

export function evaluate_sip_error(freq, tenure, installment, startdate) {

    let getDateVal = true;
    let nminst = 0;
    if (freq !== '-') {
        let prp;

        freq = freq.toUpperCase()
        if (freq === 'MONTHLY' && tenure < 12) {
            prp = 'Monthly_6';
        } else {
            prp = 'Monthly_12';
        }

        if (freq === 'ANNUAL' && tenure < 6) {
            prp = 'Annual_1';
        } else {
            prp = 'Annual_6';
        }

        if (freq === 'FORTNIGHTLY' && tenure < 12) {
            prp = 'Fortnightly_6';
        } else {
            prp = 'Fortnightly_12';
        }

        if (freq === 'QUARTERLY' && tenure < 6) {
            prp = 'Quarterly_4';
        } else {
            prp = 'Quarterly_6';
        }

        if (freq === 'WEEKLY' && tenure < 12) {
            prp = 'Weekly_6';
        } else {
            prp = 'Weekly_12';
        }
        console.log("installment", installment);
        console.log("prp", prp);
        let tmp = parseInt(installment[prp][0]['regProcessTAT'])
        console.log("tmp", tmp)
        getDateVal = addDays(startdate, tmp)
        console.log("getDateVal", getDateVal)
    }
    return getDateVal;
}
//#endregion

//#region loadScript
export function loadScript(src) {
    return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = () => {
            resolve(true);
        };
        script.onerror = () => {
            resolve(false);
        };
        document.body.appendChild(script);
    });
}
//#endregion

//#region handlerRazorpayUPI
export const handlerRazorpayUPI = (totAmt, bucketId, orderId) => {

    // this code for upi
    var options = {
        key: process.env.REACT_APP_QUICKBUY_RAZORPAY_KEY,
        // 'rzp_live_0TJNT6y58IGCnO',
        // "rzp_test_6uhrTvYEUBR6f9",
        // "rzp_test_tDMWADTX59phwL",
        // "rzp_test_tKwDDpiqbHlqea",
        // process.env.REACT_APP_RAZORPAY_KEY,
        "amount": totAmt * 100,
        "currency": "INR",
        "name": "",
        "description": "",
        image: 'https://www.motilaloswalmf.com/mf/assets/img/logo.png',
        "order_id": orderId,
        // email: false,
        "redirect": true,
        // "handler": function (response) {
        //  console.log("response", response)
        // },
        callback_url: process.env.REACT_APP_QUICKBUY_CALLBACK_URL + "?razorpayUPI",
        "notes": {
            "ChildOrderId": "",
            "Amount": totAmt,
            "BucketID": bucketId
        },
        "theme": {
            "color": "#3399cc"
        }
    }

    console.log("handlerRazorpayUPI options ", JSON.stringify(options))
    var rzp1 = new window.Razorpay(options)
    rzp1.open();
}
//#endregion

//#region razorpayDirectPayment
export const razorpayDirectPayment = (totAmt, bucketId, orderId, bankKey) => {
    var razorpay = new window.Razorpay({
        key: process.env.REACT_APP_QUICKBUY_RAZORPAY_KEY,
        //'rzp_live_ViTxSz3ncXmVKg',
        //process.env.REACT_APP_RAZORPAY_KEY, //'rzp_live_ViTxSz3ncXmVKg', //"rzp_live_0TJNT6y58IGCnO"
        image: 'https://www.motilaloswalmf.com/mf/assets/img/logo.png',
        redirect: true
    });

    var data = {
        amount: totAmt * 100, //parseInt(totAmt)
        currency: "INR",
        // email: "",
        // contact: "",
        notes: {
            "ChildOrderId": "",
            "Amount": totAmt,
            "BucketID": bucketId
        },
        order_id: orderId,
        method: "netbanking",
        bank: bankKey,
        callback_url: process.env.REACT_APP_QUICKBUY_CALLBACK_URL + "?razorpay"
    };
    console.log("handlerRazorpay razorpay data", JSON.stringify(data))
    razorpay.createPayment(data);
}
//#endregion
export function amountSeparateByCommas(x) {
    // let val = x.toString().split('.')[0];
    let val = x?.toString()?.split('.')?.[0] ?? "";
    var lastThree = val.substring(val.length - 3);
    var otherNumbers = val.substring(0, val.length - 3);
    if (otherNumbers !== '')
        lastThree = ',' + lastThree;
    var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    return res;
}

export function convertDateFormat(date) {
    const months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    const tmpDate = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    let formatted_date = date.getFullYear() + "-" + (months[date.getMonth()]) + "-" + tmpDate;
    return formatted_date
}

export function toInrFunction(number) {
    let value = number && number.valueOf();
    let a = 0
    if (number === true) {
        value = parseInt(value).toFixed(2)
        a = 2
    }
    value = number && number.valueOf() && number.valueOf().toString()
    const formatter = new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: `${a}`
        // maximumSignificantDigits: 3,
    })
    return formatter.format(value)
}

// export function convertNumberToRound(value) {
//     var val = Math.abs(value)
//     if (val >= 10000000) {
//       val = (val / 10000000).toFixed(2)+' cr';
//     //   val = Math.ceil(val) + 'cr'
//     } else if (val >= 100000) {
//       val = (val / 100000).toFixed(2)
//       val = Math.ceil(val) + ' lakhs';
//     }
//     return val;
//   } 

export function convertNumberToRound(value) {
    var val = Math.abs(value)
    if (val >= 10000000) {
        val = (val / 10000000).toFixed(2);
        val = val.replace(/\.0+$/, '') + ' cr';
    } else if (val >= 100000) {
        val = (val / 100000).toFixed(2)
        val = val.replace(/\.0+$/, '') + ' lakhs';
    } else {
        val = amountSeparateByCommas(val)
    }
    return val;
}
export function isValidUrl(urlString) {
    var urlPattern = new RegExp('^(https?:\\/\\/)?' + // validate protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
        '(\\#[-a-z\\d_]*)?$', 'i'); // validate fragment locator
    return !!urlPattern.test(urlString);
}

export function isIndividualPanNumber(panNumber) {
    const individualPanCharacter = 'P'
    return panNumber.charAt(3) === individualPanCharacter;
}

export function isAdminUser() {
    if (localStorage.getItem('userRole')) {
        const currentRole = JSON.stringify(localStorage.getItem('userRole') || "{}");
        return currentRole?.success
    }
}

export const someDelay = (delayTime, value) => {
    return new Promise((resolve, reject) => {
        setTimeout(() => resolve(value),
            delayTime
        )
    })
}

export const dailysipCal = (day, month, year, weekDate, currDate) => {
    let convertDate = moment(`${day}-${month}-${year}`, "DD-MM-YYYY");
    let convertweekDay = new Date(convertDate).getDay();
    let data = [0, 6];
    let indOf = data.indexOf(convertweekDay);
    let monthArray = [29, 30, 31];
    let checkExist = monthArray.indexOf(parseInt(day));

    if (checkExist >= 0) {
        day = 1;
        var currentDate = moment(`${day}-${month}-${year}`, "DD-MM-YYYY");
        var futureMonth = moment(currentDate).add(1, 'M').format("DD-MM-YYYY");
        let weekDay = new Date(futureMonth).getDay();
        let indOfFuture = data.indexOf(weekDay);
        if (indOfFuture === 0) {
            return moment(currDate.toString(), "DD-MM-YYYY").add(1, 'days').format("DD-MM-YYYY");
        } else if (indOfFuture === 1) {
            return moment(currDate.toString(), "DD-MM-YYYY").add(2, 'days').format("DD-MM-YYYY");
        } else {
            return futureMonth;
        }
    }
    else if (indOf === 0) {
        return moment(currDate.toString(), "DD-MM-YYYY").add(1, 'days').format("DD-MM-YYYY");
    } else if (indOf === 1) {
        return moment(currDate.toString(), "DD-MM-YYYY").add(2, 'days').format("DD-MM-YYYY");
    } else {
        return currDate
    }
}

export const calWeekdays = (todaydate, enddate) => {
    // // Calculate weekdays between the two dates
    let currentDate = todaydate.clone();
    let weekdays = 0;
    let countAlldays = 0;
    let monthArray = [29, 30, 31];
    while (currentDate.isSameOrBefore(enddate, 'day')) {
        let checkExist = monthArray.indexOf(currentDate.date());
        // Check if the current day is a weekday (Monday to Friday)
        if (currentDate.day() >= 1 && currentDate.day() <= 5 && checkExist === -1) {
            weekdays++;
        }
        countAlldays = countAlldays + 1
        // Move to the next day
        currentDate.add(1, 'day');
    }

    return { weekdays: weekdays, countAlldays: countAlldays }
}

export const cal30WokingDays = (date, installments = 30) => {
    let currentDate = moment(date.toString(), "DD-MM-YYYY")
    let weekdays = 0;
    let countAlldays = 0;
    let monthArray = [29, 30, 31];
    while (weekdays < installments) {
        let checkExist = monthArray.indexOf(currentDate.date());
        // Check if the current day is a weekday (Monday to Friday)
        if (currentDate.day() >= 1 && currentDate.day() <= 5 && checkExist === -1) {
            weekdays++;
        }
        countAlldays = countAlldays + 1
        currentDate.add(1, 'day');
    }

    return { weekdays: weekdays, countAlldays: countAlldays }
}

export const getPurposeValue = ({ otpMaster = [], type }) => otpMaster?.find?.(obj => obj.textValue === type)?.id || 0;

export function matchDatewithcurrentDateToShowNFO(matchDate) {
    const currentTime = moment();
    const targetMoment = moment(matchDate).set({ // Create target moment
        hour: 0,
        minute: 0,
        second: 0, // Set seconds to 0 for exact time check
    });

    const isAfterTarget = currentTime.isAfter(targetMoment);
    // var isafter = moment(new Date()).isAfter(matchDate);
    if (isAfterTarget) {
        return true;
    } else {
        return false;
    }
}

export const getUcid = () => {
    let ucid;
    if (typeof window !== "undefined") {
        let userInfo = getDecryptedItem('userInfo');
        userInfo = userInfo ? userInfo : {};
        ucid = userInfo?.client_UCID;
    }
    return ucid;
}

export const formatDateWithMoment = (dateString, hours = 0, minutes = 0, seconds = 0) => {
    const date = moment(dateString);
    date.set({ hour: hours, minute: minutes, second: seconds });

    return date.format('M/D/YYYY h:mm:ss A');
};


export const textFormatDateWithMoment = (date) => {
    return moment(date).format('DD MMM YYYY');
};

export const getAuthTypesForSelectedBank = (selectedBankId, selectedBankName, emandateAuthTypes) => {
    // Convert bankName to uppercase to standardize comparison
    const bankNameSubstring = selectedBankName.substring(0, 4).toUpperCase();

    // Check if the bankId matches directly
    if (emandateAuthTypes[selectedBankId]) {
        console.log("Direct match found for bankId:", selectedBankId);
        return emandateAuthTypes[selectedBankId];
    }

    // Find a matching key in emandateAuthTypes based on bank name substring
    const matchingKey = Object.keys(emandateAuthTypes).find(key => {
        const bankName = emandateAuthTypes[key].name.toUpperCase();
        const match = bankName.includes(bankNameSubstring);
        if (match) {
            console.log("Matching key found based on bank name substring:", key);
        }
        return match;
    });

    return matchingKey ? emandateAuthTypes[matchingKey] : [];
};

export const convertAuthTypesToOptions = (authTypes) => {
    return authTypes
        .filter(type => type !== 'aadhaar')  // Filter out 'aadhaar'
        .map(type => {
            const normalizedType = type?.toLowerCase();
            let label;

            // Customize the label based on the value of `type`
            if (normalizedType === 'netbanking') {
                label = 'Net Banking';
            } else if (normalizedType === 'debitcard') {
                label = 'Debit Card';
            } else if (normalizedType === 'upi') {
                label = 'UPI';
            } else {
                // Default behavior: insert space before each uppercase letter
                label = type.replace(/([A-Z])/g, ' $1').trim();
            }

            return {
                value: normalizedType, // Keep value lowercase
                label: label
            };
        });
};


export function encrypt(text, key) {
    const iv = CryptoJS.lib.WordArray.random(16);
    const encrypted = CryptoJS.AES.encrypt(text, CryptoJS.enc.Hex.parse(key), {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return iv.toString(CryptoJS.enc.Hex) + ':' + encrypted.ciphertext.toString(CryptoJS.enc.Hex);
}

export function decrypt(text, key) {
    const parts = text.split(':');
    const iv = CryptoJS.enc.Hex.parse(parts.shift());
    const encryptedText = CryptoJS.enc.Hex.parse(parts.join(':'));
    const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: encryptedText },
        CryptoJS.enc.Hex.parse(key),
        { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    );
    return decrypted.toString(CryptoJS.enc.Utf8);
}

export const setEncryptedItem = (key, value) => {
    try {
        const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), process.env.REACT_APP_ENC_KEY).toString();
        localStorage.setItem(key, encryptedValue);
    } catch (error) {
        console.error("Error storing encrypted data in localStorage:", error);
    }
};

export const encryptItem = (value) => {
    try {
        const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), process.env.REACT_APP_ENC_KEY)?.toString();
        return encryptedValue || "";
    } catch (error) {
        return "";
    }
};

export const decryptItem = (value) => {
    try {
        const encryptedValue = value;
        if (!encryptedValue) return null;

        const decryptedValue = CryptoJS.AES.decrypt(encryptedValue, process.env.REACT_APP_ENC_KEY)?.toString(CryptoJS.enc.Utf8);
        return JSON?.parse(decryptedValue) || "";
    } catch (error) {
        return "";
    }
};

export const getDecryptedItem = (key) => {
    try {
        const encryptedValue = localStorage.getItem(key);
        if (!encryptedValue) return null;

        const decryptedValue = CryptoJS.AES.decrypt(encryptedValue, process.env.REACT_APP_ENC_KEY).toString(CryptoJS.enc.Utf8);
        return JSON.parse(decryptedValue);
    } catch (error) {
        console.error("Error retrieving or decrypting data from localStorage:", error);
        return null;
    }
};

export const checkPanAndSetStorage = (panNumber, isNewUser = false) => {
    const isHUF = panNumber?.charAt(3).toUpperCase() === 'H';

    if (isHUF) {
        if (isNewUser) {
            localStorage.setItem('isNewHUFUser', true);
        } else {
            localStorage.setItem('isExistingHUFUser', true);
        }
    } else {
        if (typeof window !== "undefined") {
            localStorage.removeItem("isExistingHUFUser");
            localStorage.removeItem("isNewHUFUser");
        }
    }

    return isHUF;
};

export const checkHUFUser = () => {
    if (typeof window === "undefined") return false;

    return (
        localStorage.getItem("isExistingHUFUser") === "true" ||
        localStorage.getItem("isNewHUFUser") === "true"
    );
};

export const checkExistingHUFUser = () => {
    if (typeof window === "undefined") return false;
    return localStorage.getItem("isExistingHUFUser") === "true"
};

export const checkNewHUFUser = () => {
    if (typeof window === "undefined") return false;
    return localStorage.getItem("isNewHUFUser") === "true"
};

export const HUFUserMSG = "Folio creation for Non-Individual - HUF investors is available through physical onboarding only. Please share your details, and our representative will contact you shortly.";

export function validateNomineePAN(panNumber) {
    const individualPanCharacters = ['P', 'T'];
    return individualPanCharacters.includes(panNumber?.charAt(3)?.toUpperCase());
}

export function isValidNewEmail(email) {
    const panRegex = RegExp(regEx.emailRegex);
    return panRegex.test(email)
}

export const getInvestorType = (pan) => {
    if (!pan) pan = getDecryptedItem("userInfo")?.paN_NO;
    if (!pan || pan.length !== 10) return "Invalid PAN";

    const fourthChar = pan.charAt(3).toUpperCase();

    const investorTypes = {
        "P": "EI",  // Eligible Individual
        "H": "ENI", // Eligible Non-Individual (HUF)
        "C": "NI",  // Non-Individual (Company)
        "F": "NI",  // Non-Individual (Firm)
        "A": "NI",  // Non-Individual (AOP)
        "T": "NI",  // Non-Individual (Trust)
        "L": "NI",  // Non-Individual (Local Authority)
        "G": "NI"   // Non-Individual (Government)
    };

    return investorTypes[fourthChar] || "Unknown Investor Type";
}

export const formatEntryDate = (entryDateStr) => {
    if (!entryDateStr) return "";
  
    const date = new Date(entryDateStr);
    if (isNaN(date.getTime())) return "";
  
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();
  
    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return "th";
      switch (n % 10) {
        case 1: return "st";
        case 2: return "nd";
        case 3: return "rd";
        default: return "th";
      }
    };
  
    return `${day}${getOrdinal(day)} ${month} ${year}`;
  };


  export function scrollToFirstError() {
  // Find the first element with the error class or data-error attribute
  const errorField =
    document.querySelector('.input-error, .select-error, [data-error="true"]') ||
    document.querySelector('[aria-invalid="true"]') ||
    document.querySelector('.has-error input, .has-error select, .has-error textarea');
  if (errorField) {
    errorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
    // Optionally, focus the field
    if (typeof errorField.focus === 'function') errorField.focus();
  }
}
